import SlackTemplateHeader from "./SlackTemplateHeader";

export default SlackTemplateHeader;
